<div class="dialog">
  <div class="dialog__container">
    <mat-icon class="dialog__container-icon" [svgIcon]="data.icon"></mat-icon>

    <div class="dialog__container-text">
      <h1 class="title">{{ data.title }}</h1>
      <h3 class="subtitle" [innerHTML]="data.subtitle"></h3>
    </div>

    <ng-container *ngIf="data.helpCard">
      <app-blue-help-card></app-blue-help-card>
    </ng-container>
  </div>
  <section class="dialog__buttons">
    <app-button-basic *ngIf="data.buttonDisabled" (onClickButtonEvent)="closeDialog()" [bgColor]="'#fd7394'"
    [textColor]="'#ffffff'" [buttonText]="'Aceptar'" [width]="'100%'"></app-button-basic>
  </section>

</div>